'use client';

import { PricingPageNewDesign } from "@/app/quiz/pre-checkout/PricingPageNewDesign";
import { useStripeContext } from "@/context/StripeContextProvider";


export const AprilPricingPage = ({ testUser }) => {
	const { stripeData } = useStripeContext();

	console.log('AprilPricingPage', { stripeData });

	if (!stripeData || !stripeData.prices || stripeData.prices.length === 0) {
		return null;
	}

	return (
		<PricingPageNewDesign
			testUser={testUser}
			stripeData={[
				{
					customerId: stripeData.customer?.id,
					clientSecret: stripeData.annualClientSecret,
					pricePerMonth: stripeData.discounts?.year.pricePerMonth,
					priceAmount: stripeData.discounts?.year.priceAmount,
					interval: stripeData.prices[0]?.interval,
					subscriptionId: stripeData.annualSubscription?.id,
					annualSubscriptionId: stripeData.annualSubscription?.id,
					monthlySubscriptionId: stripeData.monthlySubscription?.id,
					trialEnd: stripeData.annualTrialEnd * 1000,
					discounts: stripeData.discounts?.year
				},
				{
					customerId: stripeData.customer?.id,
					clientSecret: stripeData.monthlyClientSecret,
					pricePerMonth: stripeData.discounts?.month.pricePerMonth,
					priceAmount: stripeData.discounts?.month.priceAmount,
					interval: stripeData.prices[1]?.interval,
					subscriptionId: stripeData.monthlySubscription?.id,
					annualSubscriptionId: stripeData.annualSubscription?.id,
					monthlySubscriptionId: stripeData.monthlySubscription?.id,
					trialEnd: stripeData.monthlyTrialEnd * 1000,
					discounts: stripeData.discounts?.month
				}
			]}
		/>
	);
};
